import { useCallback } from 'react';
import { editorUtils, useEditorStore, useTaskSmartGetter, ILayoutComponent } from '@diana/core';

interface IUseSyncComponentNameAndDataPathProps {
  layoutId: string;
  taskId: string | null;
  stepId: string | null;
  flowId: string | null;
}

export const useSyncComponentNameAndDataPath = (props: IUseSyncComponentNameAndDataPathProps) => {
  const { flowId, taskId } = props;

  const getFlow = useEditorStore((s) => s.getFlow);
  const getTask = useTaskSmartGetter({ taskId });

  const getFlowAndTask = useCallback(() => {
    const flow = getFlow();
    if (flow && flow.id === flowId) {
      return { flow, task: getTask(flow) };
    }
    return { flow: null, task: null };
  }, [flowId, getFlow, getTask]);

  return useCallback(
    (component: ILayoutComponent) => {
      const { flow, task } = getFlowAndTask();

      const dataPath = editorUtils.getCorrectLayoutComponentDataPath({ component, task, flow });
      if (component.dataPath !== dataPath) {
        component = { ...component, dataPath };
      }

      const name = editorUtils.getCorrectLayoutComponentName({ component, task, flow });
      if (component.name !== name) {
        component = { ...component, name };
      }

      return component;
    },
    [getFlowAndTask],
  );
};
